
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../../lib/supabase'

const AuthCallbackPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession()
        
        if (error) {
          console.error('Auth callback error:', error)
          navigate('/?error=auth_callback_failed')
          return
        }

        if (data.session) {
          // User is authenticated, redirect to home
          navigate('/?verified=true')
        } else {
          // No session, redirect to home
          navigate('/')
        }
      } catch (error) {
        console.error('Auth callback error:', error)
        navigate('/?error=auth_callback_failed')
      }
    }

    handleAuthCallback()
  }, [navigate])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Verifying your email...
        </h2>
        <p className="text-gray-600">
          Please wait while we complete your email verification.
        </p>
      </div>
    </div>
  )
}

export default AuthCallbackPage
